import * as React from 'react'
import { IFilterChipLabelProps } from '../typings'
import { ChipLabel } from './atoms'

export function FilterChipLabel(props: IFilterChipLabelProps) {
  const { mainLabel, subLabel, modeLabel } = props

  return (
    <>
      <ChipLabel>
        {mainLabel}
        {modeLabel.length > 0 ? ` - ${modeLabel}` : ''}:
      </ChipLabel>
      {` ${subLabel}`}
    </>
  )
}
